import { NgModule } from '@angular/core';
import { SharedModule } from '../../../core/shared/shared.module';
import { CustomerDetailsRouting } from './customer-details.routing';
import { CustomerDetailsComponent } from './customer-details.component';
import { CustomersRest } from './../customers.rest';
import { CustomerDetailsHeaderComponent } from './header/customer-details-header.component';
import { DictionaryRest } from '../../../dictionaries/dictionary/dictionary.rest';
import { CustomerSystemVersionsComponent } from '../customer-details/system-versions/customer-system-versions/customer-system-versions.component';
import { SystemVersionsSelectionComponent } from './system-versions/system-versions-selection/system-versions-selection.component';
import { SystemVersionRest } from '../../../configuration/system-versions/system-versions.rest';
import { EmployeesRest } from '../../employees/employee.rest';
import { EmployeesModule } from '../../employees/employes.module';
import { EmployeesListComponent } from '../../employees/employee-list/employees-list.component';
import { CustomerLicensesComponent } from './customer-licenses/customer-licenses.component';
import { LicenseModalComponent } from './customer-licenses/licenses-creation/license-modal.component';
import { CustomerEmployeesComponent } from './customer-employees/customer-employees.component';


@NgModule({
  imports: [SharedModule, CustomerDetailsRouting, EmployeesModule],
  declarations: [
    CustomerDetailsComponent,
    CustomerDetailsHeaderComponent,
    CustomerEmployeesComponent,
    CustomerSystemVersionsComponent,
      SystemVersionsSelectionComponent,
      CustomerLicensesComponent,
      LicenseModalComponent],
  entryComponents: [EmployeesListComponent],
  providers: [CustomersRest, DictionaryRest, SystemVersionRest, EmployeesRest]
})
export class CustomerDetailsModule { }
